import { render, staticRenderFns } from "./ps_org_security_questions_form.vue?vue&type=template&id=bf3b059a&"
import script from "./ps_org_security_questions_form.vue?vue&type=script&lang=js&"
export * from "./ps_org_security_questions_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports